<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Warning</h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
  </div>

  <div class="modal-body">
    <p>
      Changes to the user's Contact <strong>Name</strong> or <strong>Title</strong> will be reflected in historical records,
      reports, and documentation.
    </p>

    <p>To make changes for this user's name and/or title, and preserve historical records:</p>

    <ul>
      <li><strong>Create a new user</strong> and <strong>deactivate the existing</strong> account</li>
    </ul>

    <p>
      By clicking <strong>Proceed</strong>, you acknowledge that changes to the User's name or title will update all
      historical records, reports, and documentation.
    </p>

    <p>Should you have any questions, please contact customer support.</p>

    <div class="modal-footer mt-4">
      <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Revert</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="acknowledge()">Proceed</button>
    </div>
  </div>
</div>
